import type { UseFormReturn } from "react-hook-form";
import type { TripType } from "@ckgo2/shared/types";
import { tripVariant } from "@/lib/webHints/variants";
import type { TripFormData } from "./types";

/**
 * Varianta nápověd a viditelnosti polí editoru zájezdu (`trip` / `hotel`, řez 10).
 *
 * Řídí se HODNOTAMI FORMULÁŘE, ne uloženým řádkem: redaktor, který přepne nový zájezd na
 * Pobyt na vyžádání, vidí pole hotelu hned. Odkazy „Zobrazit na webu“ se naopak řídí uloženým
 * řádkem (`TripEditPage`), protože vedou na adresu, kterou web už má. `tripType` je ve formuláři
 * `string` (pevný select), odtud přetypování.
 */
export function useTripHintVariant(form: UseFormReturn<TripFormData>): "trip" | "hotel" {
  const { watch } = form;
  return tripVariant({
    tripType: watch("tripType") as TripType,
    fulfillmentMode: watch("fulfillmentMode"),
    tripKind: watch("tripKind"),
  });
}
